import React from 'react';
import Wrapper from '../components/Wrapper/Wrapper';

const TermsConditions = () => {
    return (
        <Wrapper>
            <div style={{ marginBottom: '4em' }}>
                <p><strong>Termini e Condizioni d'Uso di Rossomotori.it</strong></p>

                <p><strong>1. Accettazione dei Termini</strong></p>
                <p>L'accesso e l'uso del sito web Rossomotori.it (“Sito”) sono soggetti ai seguenti Termini e Condizioni d'Uso (“Termini”). Utilizzando il Sito, l'utente accetta integralmente i Termini qui indicati. Se non si accettano i Termini, l'accesso e l'uso del Sito non sono consentiti.</p>

                <p><strong>2. Modifiche ai Termini</strong></p>
                <p>Rossomotori.it si riserva il diritto di modificare, aggiornare o integrare i Termini in qualsiasi momento. Gli utenti saranno informati delle modifiche mediante avviso sul Sito. L'uso continuato del Sito dopo tali modifiche costituisce accettazione delle stesse.</p>

                <p><strong>3. Contenuti del Sito</strong></p>
                <p>Tutti i contenuti presenti su Rossomotori.it, inclusi articoli, immagini, grafici e video (“Contenuti”), sono protetti da copyright e sono di proprietà di Rossomotori.it o dei rispettivi autori. È vietata qualsiasi riproduzione, distribuzione o utilizzo non autorizzato dei Contenuti senza il previo consenso scritto del titolare dei diritti.</p>

                <p><strong>4. Uso Consentito</strong></p>
                <p>Gli utenti possono accedere e utilizzare il Sito esclusivamente per scopi personali e non commerciali. Ogni utilizzo diverso deve essere previamente autorizzato da Rossomotori.it.</p>

                <p><strong>5. Responsabilità degli Utenti</strong></p>
                <p>L'utente si impegna a non utilizzare il Sito per scopi illegali o non conformi ai Termini. È altresì vietato:</p>
                <ul>
                    <li>Pubblicare contenuti diffamatori, offensivi o non conformi alle normative vigenti.</li>
                    <li>Tentare di accedere senza autorizzazione a sistemi o dati relativi al Sito.</li>
                </ul>

                <p><strong>6. Limitazioni di Responsabilità</strong></p>
                <p>Rossomotori.it non garantisce che il Sito sia privo di errori, interruzioni o malware. L'utilizzo del Sito avviene sotto la piena responsabilità dell'utente. Rossomotori.it non è responsabile per eventuali danni derivanti dall'uso del Sito o dall'affidamento ai suoi Contenuti.</p>

                <p><strong>7. Collegamenti a Terze Parti</strong></p>
                <p>Il Sito potrebbe contenere collegamenti a siti web di terze parti. Rossomotori.it non è responsabile dei contenuti, delle politiche o delle pratiche di tali siti e non garantisce la loro accuratezza o affidabilità.</p>

                <p><strong>8. Privacy</strong></p>
                <p>L'uso del Sito è regolato dalla nostra <a href="/privacy-policy">Informativa sulla Privacy</a>. Gli utenti sono invitati a leggerla per comprendere come vengono trattati i loro dati personali.</p>

                <p><strong>9. Legge Applicabile</strong></p>
                <p>I Termini sono regolati dalla legge italiana. Qualsiasi controversia relativa all'interpretazione o all'applicazione dei Termini sarà di competenza esclusiva del foro di [indicare la città di competenza].</p>

                <p><strong>10. Contatti</strong></p>
                <p>Per qualsiasi domanda o segnalazione relativa ai Termini, è possibile contattare Rossomotori.it all'indirizzo email: <a href="mailto:info@rossomotori.it">info@rossomotori.it</a>.</p>
            </div>
        </Wrapper >
    );
}

export default TermsConditions;